import { render, staticRenderFns } from "./panel-product-item-market.vue?vue&type=template&id=811744ba&scoped=true"
import script from "./panel-product-item-market.vue?vue&type=script&lang=js"
export * from "./panel-product-item-market.vue?vue&type=script&lang=js"
import style0 from "./panel-product-item-market.vue?vue&type=style&index=0&id=811744ba&prod&lang=scss&module=true&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "811744ba",
  null
  
)

export default component.exports